function SingleNews(){
    let $container      = $('.single-content');
    let $backBtn        = $container.find('.back a');
    let referrer        = document.referrer ? new URL(document.referrer).hostname : null;
    let currentHostname = window.location.hostname;

    $backBtn.on('click', function(e) {
        e.preventDefault();

        // Check if the referrer exists and if the hostnames match
        if (referrer && referrer === currentHostname) {
            history.back(); // Go back if the referrer is from the same domain
        } else {
            window.location.href = '/news'; // Navigate to '/news' if referrer is external or not available
        }
    });
}

$(() => {
    if($('.single-post').length) SingleNews();
});
